module.exports = __webpack_public_path__ + "img/sp-1.0268e292.png";